import { render, staticRenderFns } from "./OtherLoading.vue?vue&type=template&id=55d6d8ba&scoped=true"
import script from "./OtherLoading.vue?vue&type=script&lang=js"
export * from "./OtherLoading.vue?vue&type=script&lang=js"
import style0 from "./OtherLoading.vue?vue&type=style&index=0&id=55d6d8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6d8ba",
  null
  
)

export default component.exports